import { Vector3 } from 'three';
import { TextGeometry } from 'three/examples/jsm/geometries/TextGeometry.js';
import { FontLoader } from 'three/examples/jsm/loaders/FontLoader.js';
export const getFontData = (jsonUrl) => {
    const fontLoader = new FontLoader();
    return new Promise(res => fontLoader.load(jsonUrl, res));
};
export const getBboxScaleByTextGeometry = (geom) => {
    geom.computeBoundingBox();
    const boundingBox = geom.boundingBox;
    if (!boundingBox)
        return;
    return boundingBox.getSize(new Vector3());
};
export const getBboxScaleByFont = (text, font, size, depth) => {
    const geom = new TextGeometry(text, { font, size, depth });
    return getBboxScaleByTextGeometry(geom);
};
